import { render } from "./LayoutAdmin.vue?vue&type=template&id=febb294c&scoped=true"
import script from "./LayoutAdmin.vue?vue&type=script&lang=js"
export * from "./LayoutAdmin.vue?vue&type=script&lang=js"

import "./LayoutAdmin.vue?vue&type=style&index=0&id=febb294c&lang=less&scoped=true"

import exportComponent from "/Users/kacper/IdeaProjects/e.on-portal-awarie/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-febb294c"]])

export default __exports__